"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {findIn, findAllIn, on} from "@elements/dom-utils"

export function init() {
    onFind('.js-img-slider-area', function (imgSliderArea) {
        let counter = 1;
        const scrollItems = findAllIn('.scrolling-area__item', imgSliderArea);
        let scrollArea = findIn('.js-scroll-slider__area', imgSliderArea)
        let currentCount = findIn('.js-scroll-slider__current', imgSliderArea);
        let counterIndicator = findIn('.js-scroll-slider__counter-indicator', imgSliderArea);
        let activeItem = findIn('.is-active', imgSliderArea);
        findIn('.js-scroll-slider__all-count', imgSliderArea).innerHTML = scrollItems.length.toString();
        currentCount.innerHTML = counter.toString();

        setPercent(counter, scrollItems, activeItem, currentCount, counterIndicator);

        on('scroll', function () {
            activeItem = findIn('.is-active', imgSliderArea);

            setPercent(counter, scrollItems, activeItem, currentCount, counterIndicator);
        }, scrollArea)
    })
}

function setPercent(counter, scrollItems, activeItem, currentCount, counterIndicator) {
    if (activeItem) {
        counter = scrollItems.indexOf(activeItem) + 1;
        currentCount.innerHTML = counter.toString();

        let percentage = counter / scrollItems.length * 100;
        counterIndicator.style.width = percentage + "%"
    }
}